import Axios from './axios';

export const getRolesService = () => {
  return Axios.get(`api/roles/`).then((res) => {
    return res?.data;
  });
};
